import { useTranslate } from '@refinedev/core';
import { colors } from '../../../Theme/Colors';
import { Text } from '../../text';

type Props = {
  message?: string;
};

export const NotificationMessage = ({ message }: Props) => {
  const translate = useTranslate();
  if (!message) return <Text>{translate('common.loading')}</Text>;

  return (
    <div>
      <Text
        style={{
          textAlign: 'right',
          fontWeight: '600',
        }}
        textColor={colors.notificationContent}
        size="sm"
      >
        {message || 'Unassigned'}
      </Text>
    </div>
  );
};
